module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "oak-dune-fluted-hayman-0.d07ff5ed.jpg";